module.exports = __webpack_public_path__ + "static/media/settings_newsletter.3c908338.svg";